import React from 'react';
import { NavLink } from 'react-router-dom';

import { startCase, get } from 'lodash';

import { env } from '~/commons/config';
import links from './NavList';
import NavListItem from './NavListItem.jsx';

const isDep = get(env, 'user.roles').includes('department');
const permits = get(env, 'department.permission') ?? [];
const getPermittedLinks = (ls, segmentDef = '') => ls.reduce((acc, l) => {
  const { segment, links: nestedLinks } = l;

  if (!isDep || l.required) return [...acc, l];

  if (nestedLinks) {
    l.links = getPermittedLinks(nestedLinks, segment);
    if (l.links.length === 0) return acc;
    return [...acc, l];
  }

  const { action } = permits.find(
    (p) => p.segment === (segment || segmentDef),
  ) ?? {};

  return (action === 'edit' || action === 'read') ? [...acc, l] : acc;
}, []);

const permittedLinks = getPermittedLinks(links);
const name = env?.user?.name?.full?.en || env?.user?.username;
const environment = {
  development: 'DEV',
  uat: 'UAT',
}[env?.env];
console.log('environment', environment);
const Nav = () => (
  <nav className="col main-nav bg-light pr-0 py-5">
    {
      (environment) && (
        <div className="nav pl-3 ml-3 pr-1 my-2 text-primary flex-column text-wrap text-break font-weight-bold" style={{ width: '200px' }}>
          {environment}
        </div>
      )
    }
    {name && (
      <NavLink
        className="nav pl-3 ml-3 pr-1 my-2 text-primary flex-column text-wrap text-break" style={{ width: '200px' }}
        to="/admin/users/self">
        Welcome: {startCase(name)}
      </NavLink>
    )}
    <div className="nav flex-column pl-3">
      {permittedLinks.map((l, i) => (
        <NavListItem key={i} {...l}>
          {l.links
            && l.links.map((ll, ii) => (
              <NavListItem key={ii} {...ll} />
            ))}
        </NavListItem>
      ))}
    </div>
  </nav>
);
const pSegments = permittedLinks.map(({ segment }) => segment);
const isPermitted = (segment) => pSegments.includes(segment);
export {
  Nav, links, permittedLinks, isPermitted,
};
